<template lang="html">
  <v-app light>
    <transition name="slide-fade"
      mode="out-in">
      <router-view></router-view>
    </transition>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'app',
  methods: {
    ...mapActions('roles', [
      'setToken',
    ]),
    getSessionData(key) {
      const data = sessionStorage.getItem(key) === 'undefined';
      return data ? undefined : sessionStorage.getItem(key);
    },
    getLocalData(key) {
      const data = localStorage.getItem(key) === 'undefined';
      return data ? undefined : localStorage.getItem(key);
    },
  },
  mounted() {
    const token = this.getSessionData('token') || this.getSessionData('id_magalu_access_token');
    if (token) {
      this.setToken(token);
    }
  },
  created() {
    console.log('[Vue] Created - route:', this.$route.fullPath);
  },
};
</script>

<style lang="css">
  @import '~@/assets/css/main.css';

  #app {
    background-color: #EEEEEE;
    height: 100%;
  }

  .slide-fade-enter-active {
    transition: all .1s ease;
  }
  .slide-fade-leave-active {
    transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-active {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
